module.exports = __webpack_public_path__ + "static/saara-e5ffdcd5a4aaf2334c6b38fe88a1258e.jpg";